import React from "react";

import ReactMDSelectField from "../../../common/components/ReactMDSelectField";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { required } from "../../../common/validators";
import ReactMDTextField from "../../../common/components/ReactMDTextField";
import { connect } from "react-redux";
import { Button, CardActions, FontIcon } from "react-md";
import { months, days, years, idTypes } from "../../../common/utils";
import FormInputIcon from "../../../common/components/FormInputIcon";

const IDForm = ({ handleSubmit, invalid, submitting, selectedIDType }) => (
  <div>
    <section className="md-grid">
      <FormInputIcon>perm_contact_calendar</FormInputIcon>
      <Field
        label="Month"
        placeholder="Select Month"
        className="md-cell md-cell--4 md-cell--with-icon"
        helpText="Date of Birth"
        menuItems={months}
        itemLabel="label"
        itemValue="value"
        id="dateOfBirth.month"
        name="dateOfBirth.month"
        required
        component={ReactMDSelectField}
        validate={[required]}
      />
      <Field
        label="Day"
        placeholder="Select Day"
        className="md-cell md-cell--4"
        menuItems={days}
        itemLabel="label"
        itemValue="value"
        id="dateOfBirth.day"
        name="dateOfBirth.day"
        required
        component={ReactMDSelectField}
        validate={[required]}
      />
      <Field
        label="Year"
        placeholder="Select Year"
        className="md-cell md-cell--4"
        menuItems={years}
        id="dateOfBirth.year"
        name="dateOfBirth.year"
        required
        component={ReactMDSelectField}
        validate={[required]}
      />
      <Field
        label="Identification Number"
        id="idNumber"
        name="idNumber"
        type="text"
        className="md-cell md-cell--6"
        required
        component={ReactMDTextField}
        validate={[required]}
        leftIcon={<FontIcon>card_membership</FontIcon>}
      />
      <Field
        label="Select Identification Type"
        className="md-cell md-cell--6"
        menuItems={idTypes}
        id="idType"
        name="idType"
        required
        component={ReactMDSelectField}
        validate={[required]}
      />
      {selectedIDType === "Other" &&
        <Field
          label="Enter Identification Type (Other)"
          id="idTypeOther"
          name="idTypeOther"
          type="text"
          className="md-cell md-cell--12"
          required
          component={ReactMDTextField}
          validate={[required]}
          leftIcon={<FontIcon>card_membership</FontIcon>}
        />}
    </section>
    <CardActions>
      <Button
        raised
        label="Save & Continue"
        primary
        className="md-cell--right"
        disabled={submitting || invalid}
        onClick={handleSubmit}
      />
    </CardActions>
  </div>
);

IDForm.propTypes = {};
IDForm.defaultProps = {};

const connectedForm = reduxForm({
  form: "id-form"
})(IDForm);

const formSelector = formValueSelector("id-form");

export default connect(state => ({
  selectedIDType: formSelector(state, "idType")
}))(connectedForm);



// WEBPACK FOOTER //
// ./src/registration/components/ID/IDForm.jsx